import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionHeadshotGenerator from '../../../../redux/action/FJActionHeadshotGenerator';
import FJDynamicStepFormRenderer from '../view/FJDynamicStepFormRenderer';
import { setHairColorNewOption } from '../../../../redux/slices/FJSliceHeadshotGenerator';

const FJDynamicStepFormRendererContainer = ({ currentStepIndex, selectedCategory }) => {
    const dispatch = useDispatch();

    const selectedGender = useSelector(state => state.headshotGenerator.selectedGender);
    const selectedProfession = useSelector(state => state.headshotGenerator.selectedProfession);
    const selectedHairPreferences = useSelector(state => state.headshotGenerator.selectedHairPreferences);
    const selectedClothingPreference = useSelector(state => state.headshotGenerator.selectedClothingPreference);
    const selectedBackgroundPreference = useSelector(state => state.headshotGenerator.selectedBackgroundPreference);
    const selectedTheme = useSelector(state => state.headshotGenerator.selectedTheme);
    const selectedRatio = useSelector(state => state.headshotGenerator.selectedRatio);
    const selectedShot = useSelector(state => state.headshotGenerator.selectedShot);
    const selectedCategoryKey = useSelector(state => state.headshotGenerator.selectedCategoryKey);
    const hairColorNewOption = useSelector(state => state.headshotGenerator.hairColorNewOption);
    const selectedAge = useSelector(state => state.headshotGenerator.selectedAge);
    // 处理各种选择变化的回调函数
    const handleGenderChange = useCallback(
        gender => {
            dispatch(FJActionHeadshotGenerator.setGenderAction(gender));
        },
        [dispatch],
    );

    const handleProfessionChange = useCallback(
        profession => {
            dispatch(FJActionHeadshotGenerator.setProfessionAction(profession));
        },
        [dispatch],
    );

    const handleHairPreferencesChange = useCallback(
        preferences => {
            dispatch(FJActionHeadshotGenerator.setHairPreferencesAction(preferences));
        },
        [dispatch],
    );

    const handleClothingPreferenceChange = useCallback(
        preference => {
            dispatch(FJActionHeadshotGenerator.setClothingPreferenceAction(preference));
        },
        [dispatch],
    );

    const handleBackgroundPreferenceChange = useCallback(
        preference => {
            dispatch(FJActionHeadshotGenerator.toggleBackgroundPreferenceAction(preference));
        },
        [dispatch],
    );

    const handleThemeChange = useCallback(
        theme => {
            dispatch(FJActionHeadshotGenerator.toggleThemeAction(theme));
        },
        [dispatch],
    );

    const handleRatioChange = useCallback(
        ratio => {
            dispatch(FJActionHeadshotGenerator.setRatioAction(ratio));
        },
        [dispatch],
    );

    const handleShotChange = useCallback(
        shot => {
            dispatch(FJActionHeadshotGenerator.setShotAction(shot));
        },
        [dispatch],
    );

    const handleBack = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.setCurrentStepIndexAction(0));
    }, [dispatch]);

    const handleHairColorNewOptionChange = useCallback(
        hairColorNewOption => {
            dispatch(setHairColorNewOption(hairColorNewOption));
        },
        [dispatch],
    );

    const handleAgeChange = useCallback(
        age => {
            dispatch(FJActionHeadshotGenerator.setAgeAction(age));
        },
        [dispatch],
    );

    return (
        <FJDynamicStepFormRenderer
            currentStepIndex={currentStepIndex}
            selectedCategory={selectedCategory}
            selectedCategoryKey={selectedCategoryKey}
            selectedGender={selectedGender}
            selectedProfession={selectedProfession}
            selectedHairPreferences={selectedHairPreferences}
            selectedClothingPreference={selectedClothingPreference}
            selectedBackgroundPreference={selectedBackgroundPreference}
            selectedTheme={selectedTheme}
            selectedRatio={selectedRatio}
            selectedShot={selectedShot}
            onGenderChange={handleGenderChange}
            onProfessionChange={handleProfessionChange}
            onHairPreferencesChange={handleHairPreferencesChange}
            onClothingPreferenceChange={handleClothingPreferenceChange}
            onBackgroundPreferenceChange={handleBackgroundPreferenceChange}
            onThemeChange={handleThemeChange}
            onRatioChange={handleRatioChange}
            onShotChange={handleShotChange}
            onBack={handleBack}
            hairColorNewOption={hairColorNewOption}
            setHairColorNewOption={handleHairColorNewOptionChange}
            selectedAge={selectedAge}
            onAgeChange={handleAgeChange}
        />
    );
};

FJDynamicStepFormRendererContainer.propTypes = {
    currentStepIndex: PropTypes.number.isRequired,
    selectedCategory: PropTypes.string.isRequired,
};

export default FJDynamicStepFormRendererContainer;
